import { ColorantCellDraft } from '../types'

/** Колорант выбран, а граммы не указаны — ячейку подсвечиваем. */
export function isAmountMissing(cell: ColorantCellDraft) {
    return Boolean(cell.colorantDocumentId) && !cell.amount
}
